<template>
  <div id="main-wrapper pt-0" class="show">
    <div class="header landing_page">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <nav class="navbar navbar-expand-lg navbar-light px-0">
              <router-link class="navbar-brand" to="/demo"
                ><img src="../assets/images/w_logo.png" alt="" />
                <span>OTC919</span></router-link
              >
              <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

              <b-collapse as="div" id="nav-collapse" is-nav>
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#intro"
                      @click="active = 'home'"
                      :class="active === 'home' && 'active'"
                      >Home</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#demo"
                      @click="active = 'demo'"
                      :class="active === 'demo' && 'active'"
                      >Demo</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#Support"
                      @click="active = 'support'"
                      :class="active === 'support' && 'active'"
                      >Support</a
                    >
                  </li>
                </ul>
              </b-collapse>
              <div class="dashboard_log">
                <div class="d-flex align-items-center">
                  <div class="header_auth">
                    <router-link to="/signin" class="btn btn-success"
                      >Buy</router-link
                    >
                    <a
                      href="https://www.fiverr.com/quixlab"
                      class="btn btn-outline-primary"
                      target="_blank"
                      >Hire me</a
                    >
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <div
      class="intro section-padding position-relative"
      id="intro"
      data-scroll-index="0"
    >
      <div class="container">
        <div class="row align-items-center justify-content-between">
          <div class="col-xl-6 col-md-6">
            <div class="intro-content">
              <h2>The complete Cryptocurrency Exchange HTML Template</h2>
              <p>
                Sign in, Signup, Phone and ID card verification, One time
                password verify and add bank, debit card settings and profile
                etc pages included.
              </p>
              <a href="#" class="btn" data-scroll-nav="1">View Demo</a>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 py-md-5">
            <div class="demo_img">
              <img
                src="../assets/images/portfolio.png"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="demo" class="market section-padding page-section">
      <div class="container">
        <div class="row py-lg-5 justify-content-center">
          <div class="col-xl-6">
            <div class="section_heading">
              <span>Explore</span>
              <h3>The Complete OTC919 Crafted Design Pages</h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/portfolio.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Dashboard</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/buy-sell" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/buy-sell.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Buy and Sell</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/accounts" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/accounts.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Accounts</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/settings" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/edit-profile.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Edit Profile</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/settings-preferences" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/preferences.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Preferences</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/settings-security" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/security.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Security</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/settings-account" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/linked-account.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Linked Account</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/history" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/history.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>History</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/signin" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/signin.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Signin</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/signup" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/signup.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Signup</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/reset" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/reset.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Reset</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/lock" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/lock.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Locked</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/otp-1" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/otp-phone.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>OTP Number</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/otp-2" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/otp-code.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>OTP Code</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/verify-step-1" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/verify-id.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Verify ID</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/verify-step-2" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/upload-id.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Upload ID</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/verify-step-3" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/id-verifing.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>ID Verifying</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/verify-step-4" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/id-verified.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>ID Verified</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/add-debit-card" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/add-debit-card.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Add Debit Card</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/verify-step-6" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/success.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Success</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/new_bank_account" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/choose-account.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Recommendation</h4>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-sm-6">
            <div class="demo_img">
              <router-link to="/add-bank-acc" target="_blank">
                <div class="img-wrap">
                  <img
                    src="../assets/images/demo/add-bank.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </router-link>
              <h4>Add Bank Account</h4>
            </div>
          </div>
          <!-- <div class="col-xl-3 col-md-4 col-sm-6">
                        <div class="demo_img">
                            <router-link to="/about" target="_blank">
                                <div class="img-wrap">
                                    <img src="../assets/images/demo/about.png" alt="" class="img-fluid">
                                </div>
                            </a>
                            <h4>About US</h4>
                        </div>
                    </div> -->
          <!-- <div class="col-xl-3 col-md-4 col-sm-6">
                        <div class="demo_img">
                            <router-link to="/privacy-policy" target="_blank">
                                <div class="img-wrap">
                                    <img src="../assets/images/demo/privacy.png" alt="" class="img-fluid">
                                </div>
                            </a>
                            <h4>Privacy Policy</h4>
                        </div>
                    </div> -->
          <!-- <div class="col-xl-3 col-md-4 col-sm-6">
                        <div class="demo_img">
                            <router-link to="/term-condition" target="_blank">
                                <div class="img-wrap">
                                    <img src="../assets/images/demo/terms.png" alt="" class="img-fluid">
                                </div>
                            </a>
                            <h4>Terms & Condition</h4>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";

export default {
  components: { Footer },
  data() {
    return {
      active: "home",
    };
  },
};
</script>
